import { FC } from 'react';
import { INormalizedPlayerData, INormalizedTeamData, INormalizedTournamentData, ISubscriberInfo } from '../../../../types';
import { SMPLinkWrapper, SMPSportEntity, SMPText, styled } from '../../../index';
import { defaultHandleTournamentClick } from '@sportal365/smp-widget-utils';

export interface ISubHeaderProps {
  tournamentOne: INormalizedTournamentData | undefined;
  seasonOne: INormalizedTeamData['season'] | INormalizedPlayerData['season'];
  tournamentTwo: INormalizedTournamentData | undefined;
  seasonTwo: INormalizedTeamData['season'] | INormalizedPlayerData['season'];
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

export const SubHeader: FC<ISubHeaderProps> = ({ tournamentOne, seasonOne, tournamentTwo, seasonTwo, handleClick }) => {
  if (!tournamentOne || !tournamentTwo) {
    return null;
  }

  const handleTournamentClick = () => defaultHandleTournamentClick(handleClick, Number(tournamentOne.id), tournamentOne.name);

  return (
    <Wrapper>
      <SMPLinkWrapper href={tournamentOne.tournamentLink} target={tournamentOne.urlTarget} onClick={handleTournamentClick}>
        <TournamentWrapper align='left'>
          <TournamentLogo style={{ backgroundImage: `url("${tournamentOne.logo ?? tournamentOne.tournamentImage}")` }} />
          <SMPText size='3' weight='700' variant='contrast' css={{ lh: '$4' }}>
            {tournamentOne.name}
          </SMPText>
          <SMPText size='2' weight='400' variant='contrast' css={{ lh: '18px' }}>
            {seasonOne.name}
          </SMPText>
        </TournamentWrapper>
      </SMPLinkWrapper>
      <SMPLinkWrapper href={tournamentTwo.tournamentLink} target={tournamentTwo.urlTarget}>
        <TournamentWrapper align='right'>
          <TournamentLogo style={{ backgroundImage: `url("${tournamentTwo.logo ?? tournamentOne.tournamentImage}")` }} />
          <SMPText size='3' weight='700' variant='contrast' css={{ lh: '$4' }}>
            {tournamentTwo.name}
          </SMPText>
          <SMPText size='2' weight='400' variant='contrast' css={{ lh: '18px' }}>
            {seasonTwo.name}
          </SMPText>
        </TournamentWrapper>
      </SMPLinkWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.withConfig({ componentId: 'SubHeader', displayName: 'Wrapper' })('div', {
  display: 'flex',
  justifyContent: 'space-between',
  background: '$subHeaderBgColor',
  mb: '$5',
  '@bp1': {
    mx: 10,
  },
});

const TournamentWrapper = styled.withConfig({ componentId: 'SubHeader', displayName: 'TournamentWrapper' })('div', {
  display: 'grid',
  columnGap: '$2',
  alignItems: 'center',
  width: '50%',
  p: '$2',
  variants: {
    align: {
      left: {
        gridTemplateColumns: 'auto 1fr',
        gridTemplateAreas: '"logo name" "logo season"',
      },
      right: {
        gridTemplateColumns: '1fr auto',
        gridTemplateAreas: '"name logo" "season logo"',
        '& span': {
          textAlign: 'right',
        },
      },
    },
  },
  [`& ${SMPSportEntity}`]: {
    color: 'unset',
  },
});

const TournamentLogo = styled.withConfig({ componentId: 'SubHeader', displayName: 'TournamentLogo' })('div', {
  gridArea: 'logo',
  alignSelf: 'start',
  width: '$6',
  height: '$6',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  '@bp1': { width: '$6' },
});
